import script from "./CrosswordGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./CrosswordGrid.vue?vue&type=script&setup=true&lang=js"

import "./CrosswordGrid.vue?vue&type=style&index=0&id=b92a37e8&scoped=true&lang=css"

import exportComponent from "C:\\Cwiczenia Programowanie Wojtek\\Vue Shop-FCC\\lang-cross\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b92a37e8"]])

export default __exports__